/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  Col,
  // Container,
  Input,
  Row,
  Table,
} from 'reactstrap'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { fetchData, _fetchApi } from '../api'
import Gray from '../Gray'
import NewAverage from '../NewAverage'
// import SideBar from "./SideBar";
import UserGuide from '../UserGuide'
import WestAfricaData from '../WestAfricaData'

export default function AnnualChange({ type }) {
  // const [displayedGraph, setDisplayedGraph] = useState("Line");
  const [yearList, setYearList] = useState([])
  const [report, setReport] = useState([])
  const [rawData, setRawData] = useState([])
  const [data, setData] = useState([])
  const [form, setForm] = useState({
    // indicator: ['Regional Indicator'],
    indicator: ["Real GDP Growth (Annual percent change)"],
    country: ["Regional Outlook"],
    year_from: "2002",
    year_to: "2022",
    region: "Sub-Saharan Africa",
    type_of_data: "World Economic Outlook",
    new_indicator: ["GDP based on PPP, share of world (Percent of World)"],
  });
  const [countryList, setCountryLust] = React.useState([])
  const [indicatorList, setIndicatorList] = useState([])
  const [indicator, setIndicator] = useState([])
  const [indicatorByCountry, setIndicatorByCountry] = useState([])
  const [dataByEachCountry, setdataByEachCountry] = useState([])

  let [stage, setStage] = useState(1)
  let [display, setDisplay] = useState(false)
  const in_years =
    form.year_from === form.year_to
      ? 1
      : parseInt(form.year_to) - parseInt(form.year_from)
  const navigate = useNavigate()

  React.useEffect(() => {
    fetchData({ query_type: 'get_countries' })
      .then((d) => {
        if (d && d.results) {
          setCountryLust([
            'Regional Outlook',
            ...d.results.map((a) => a.country),
          ])
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }, [])

  React.useEffect(() => {
    fetchData({ query_type: 'get_indicators', type_of_data: form.type_of_data })
      .then((d) => {
        if (d && d.results) {
          setIndicatorList([
            // 'Regional Indicator',
            ...d.results.map((a) => a.indicator),
          ])
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }, [form.type_of_data])

  useEffect(() => {
    fetchData({
      query_type: 'get_years',
    })
      .then((d) => {
        if (d && d.results) {
          setYearList(d.results.map((a) => a.year))
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }, [])

  useEffect(() => {
    if (form.country.includes('Regional Outlook')) {
      fetchData({ query_type: 'by_region', ...form })
        .then((d) => {
          if (d && d.results) {
            setRawData(d.results)
            let finalData = []

            d.results.forEach((i) => {
              finalData.push({
                name: i.indicator,
                average: i.average,
                pv: 400,
                // amt: i.amount,
              })
            })

            setReport(finalData)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    } else {
      fetchData({ query_type: 'by_country', ...form })
        .then((d) => {
          if (d && d.results) {
            setRawData(d.results)
            // console.log(d.results, "LLLLLL");
            let finalData = []

            d.results.forEach((i) => {
              finalData.push({
                name: i.year,
                [i.indicator]: i.amount,
                // amt: i.amount,
              })
            })

            setReport(finalData)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }, [form])

  const handleChange = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }))

  const getAnnualPercentageChange = useCallback(() => {
    _fetchApi(
      `/query-data?query_type=annual_change&year_from=${form.year_from}&year_to=${form.year_to}&country=${form.country}&region=${form.region}&type_of_data=${form.type_of_data}&indicator=${form.indicator}`,
      (d) => {
        setData(d.results)
      },
      (err) => {
        console.log(err)
      },
    )
  }, [
    form.year_from,
    form.year_to,
    form.country,
    form.type_of_data,
    form.region,
    form.indicator,
  ])

  useEffect(() => {
    getAnnualPercentageChange()
  }, [getAnnualPercentageChange])
  const stageOne = stage === 1
  let countryCon = form.country.includes('Regional Outlook')

  return (
    <>
      <Button onClick={() => navigate(-1)} color="warning">
        Go back
      </Button>
      <Row>
        <Col md={9}>
          {/* {JSON.stringify(indicatorByCountry)} */}
          <CardBody>
            {/* <Row>
              <Col md={6}> */}
            <label className="text-white">Select Indicator</label>
            <Input
              type="select"
              value={form.indicator}
              name="indicator"
              onChange={({ target: { value } }) =>
                setForm((p) => ({ ...p, indicator: [value] }))
              }
            >
              {indicatorList.map((indicator, id) => (
                <option key={id} value={indicator}>
                  {indicator}
                </option>
              ))}
            </Input>
            {/* </Col>
              <Col md={6}>
                <label className="text-white">Select Country</label>
                <Input
                  type="select"
                  value={form.country}
                  name="country"
                  onChange={handleChange}
                >
                  {countryList.map((country, id) => (
                    <option key={id} value={country}>
                      {country}
                    </option>
                  ))}
                </Input>
              </Col>
            </Row> */}
            <Card className="p-3 mt-3">
              <h3 className="text-center">
                {stageOne ? 'Annual Percentage Change' : form.indicator} -{' '}
                {form.country} ({form.year_from} - {form.year_to})
              </h3>

              {/* <Gray report={report} indicator={form.indicator} /> */}
            </Card>
          </CardBody>

          <div>
            <div style={{ height: '70vh', overflow: 'auto' }} className="card">
              <Table bordered striped>
                <thead>
                  <tr>
                    <th className="text-center">Year</th>
                    <th className="text-center">Value</th>
                    {/* <th className="text-center">Year</th> */}
                    <th className="text-center">Percentage change</th>
                    <th className="text-center">Average</th>
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data.map((d, i) => (
                      <tr key={i}>
                        <td
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            //   if (stageOne) {
                            //     setForm((p) => ({
                            //       ...p,
                            //       indicator: [d.indicator],
                            //     }));
                            //   } else {
                            //     setForm((p) => ({
                            //       ...p,
                            //       country: [d.country],
                            //     }));
                            //   }
                            //   setStage(stage + 1);
                            //   console.log(d.indicator, "Clicked country");
                          }}
                          className="text-center"
                        >
                          {d.year} - {d.year_two}
                        </td>
                        <td className={'text-end'}>
                          {((d.amount * 100) / 100).toFixed(5)}
                        </td>
                        {/* <td className={'text-end'}>{d.year_two}</td> */}
                        <td className={'text-end'}>
                          {((d.growth * 100) / 100).toFixed(5)}
                        </td>
                        <td className={'text-end'}>
                          {((d.average * 100) / 100).toFixed(5)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </div>
          <Card
            body
            className="p-3 mt-3"
            style={{ height: '70vh', overflow: 'auto' }}
          >
            <h3 className="text-center">
              {stageOne ? 'Annual Percentage Change' : form.indicator} -{' '}
              {form.country} ({form.year_from} - {form.year_to})
            </h3>
            <BarChart
              width={1000}
              height={380}
              data={data.map((a) => ({
                ...a,
                range: `${a.year} - ${a.year_two}`,
                'Percentage change': a['growth'],
              }))}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="range" angle={-45} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Percentage change" fill="#8884d8" />
            </BarChart>
            {/* <Gray
              report={data}
              // report={form.country[0] === "Regional Outlook" ? data : newArr}
              indicator={form.indicator}
              stageOne={stageOne}
            /> */}
          </Card>
        </Col>
        <Col md={3}>
          {/* <small>{JSON.stringify(yearList)}</small> */}
          <label className="text-white">Date range</label>
          <Row className="mb-3">
            <Col md={6} className="m-0 pe-1">
              <Input
                type="select"
                value={form.year_from}
                name="year_from"
                onChange={handleChange}
              >
                {yearList.map((indicator, id) => (
                  <option key={id} value={indicator}>
                    {indicator}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={6} className="m-0 ps-1">
              <Input
                type="select"
                value={form.year_to}
                name="year_to"
                onChange={handleChange}
              >
                {yearList.map((indicator, id) => (
                  <option key={id} value={indicator}>
                    {indicator}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
          <UserGuide stage={stage} />
        </Col>
      </Row>
    </>
  )
}
